import React from "react";

const Ranking = () => {
	return <div></div>;
};

export default Ranking;
